// extracted by mini-css-extract-plugin
export var dateTimeButton = "_fr-1";
export var dateTimeButtonsContainer = "_fr-6";
export var dateTimeInputContainer = "_fr-7";
export var dateTimeWrapper = "_fr-8";
export var disabledTile = "_fr-0";
export var header = "_fr-2";
export var line = "_fr-3";
export var snoozeOption = "_fr-4";
export var time = "_fr-5";
export var todayTile = "_fr-9";
export var wrapper = "_fr-a";